var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_vm.showTask ? _c('contentTask', {
    attrs: {
      "value": _vm.value,
      "tp-source": _vm.tpSource || '',
      "std-tag": _vm.stdTag || '',
      "is-dark": _vm.isDark
    },
    on: {
      "clickTask": _vm.goBdLogin,
      "showTask": _vm.onShowTask
    }
  }) : _c('circleTask', {
    attrs: {
      "value": _vm.value,
      "tp-source": _vm.tpSource || '',
      "std-tag": _vm.stdTag || '',
      "is-dark": _vm.isDark
    },
    on: {
      "clickTask": _vm.goBdLogin
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };